import { render, staticRenderFns } from "./BulkBuying.vue?vue&type=template&id=193fa338&scoped=true"
import script from "./BulkBuying.vue?vue&type=script&lang=js"
export * from "./BulkBuying.vue?vue&type=script&lang=js"
import style0 from "./BulkBuying.vue?vue&type=style&index=0&id=193fa338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193fa338",
  null
  
)

export default component.exports